import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  error: "",
  message: "",
};

export const deleteOfferAction = createAsyncThunk(
  "delete-offer",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.delete(`/admins/api/deleteOffer`, {
        data: { offerId: data.offerId },
      });
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteOfferSlice = createSlice({
  name: "delete-offer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(deleteOfferAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteOfferAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(deleteOfferAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const deleteOfferReducer = deleteOfferSlice.reducer;
